const normaliseHtml = html => html
  .replace('\n', '<br>')

export default normaliseHtml



// WEBPACK FOOTER //
// ./src/utils/normaliseHtml.js